{
  "title": "Facture",
  "number": "N° Facture",
  "date": "Date",
  "due_date": "Date d'échéance",
  "customer": "Client",
  "items_table": {
    "description": "Désignation",
    "quantity": "Qté",
    "unit_price": "Prix unitaire HT",
    "total": "Total HT"
  },
  "summary": {
    "subtotal_ht": "Sous-total HT",
    "tva": "TVA (18%)",
    "total_ttc": "Total TTC"
  },
  "status": {
    "label": "Statut",
    "draft": "Brouillon",
    "issued": "Émise",
    "paid": "Payée",
    "cancelled": "Annulée",
    "refunded": "Remboursée"
  },
  "actions": {
    "view": "Voir",
    "download_pdf": "Télécharger PDF",
    "print": "Imprimer",
    "send_email": "Envoyer par email"
  },
  "company": {
    "legal_notice": "CIEDA SARL — Hann Mariste II, Dakar, Sénégal",
    "ninea": "NINEA",
    "rc": "RC",
    "payment_terms": "Conditions de paiement : Paiement à la commande"
  },
  "list": {
    "title": "Mes factures",
    "column_status": "Statut",
    "empty": "Aucune facture",
    "empty_description": "Vos factures apparaîtront ici après votre première commande"
  },
  "customer_page": {
    "title": "Mes factures",
    "empty_title": "Aucune facture disponible",
    "empty_message": "Vos factures apparaîtront ici après vos commandes."
  },
  "admin": {
    "title": "Gestion des factures",
    "column_number": "N° Facture",
    "column_date": "Date",
    "column_customer": "Client",
    "column_total": "Total TTC",
    "column_status": "Statut",
    "column_actions": "Actions",
    "filter_all": "Toutes",
    "filter_issued": "Émises",
    "filter_paid": "Payées",
    "filter_cancelled": "Annulées",
    "search_placeholder": "Rechercher une facture…",
    "pagination_of": "sur",
    "pagination_results": "résultats",
    "no_results": "Aucun résultat",
    "no_results_description": "Aucune facture ne correspond à vos critères de recherche."
  },
  "qr": {
    "scan_to_verify": "Scannez pour vérifier"
  }
}
